import React, {useState} from 'react';
import {DialogContent} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import ModalDialog from "./ModalDialog";
import {inputStyles} from "../shared";
import TextField from '@material-ui/core/TextField';
import {makeStyles} from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import SubmitIcon from "@material-ui/icons/Email";
import Typography from "@material-ui/core/Typography";
import NumberFormat from "react-number-format";
import {Alert} from "@material-ui/lab";

const useStyles = makeStyles({input: inputStyles});

export interface EmailOptionForm {
    name: string
    email: string
    phone: string
    city: string
    state: string
    zipCode: string
    comments: string
}

export type Props = {
    open?: boolean
    onCancel: () => void
    onSubmit: (data: EmailOptionForm) => void
}

function EmailOptionsDialog({onCancel, onSubmit, open = false}: Props) {
    const [name, setName] = useState(""),
        [email, setEmail] = useState(""),
        [phone, setPhone] = useState(""),
        [city, setCity] = useState(""),
        [state, setState] = useState(""),
        [zipCode, setZipCode] = useState(""),
        [comments, setComments] = useState(""),
        [errors, setErrors] = useState(""),
        classes = useStyles();

    return (
        <ModalDialog open={open} onClose={onCancel}
                     title="Submit Inquiry"
                     content={<>
                         <DialogContent>
                             <Typography variant="body2" component="p" color="secondary">
                                 Thanks for your inquiry!<br/>
                                 We’ll get back to you within 24 hours with more
                                 Information about this floor plan.
                             </Typography>
                             <Grid container spacing={2} style={{marginTop: '1rem'}}>
                                 <Grid item xs={12}>
                                     <TextField value={name} onChange={e => setName(e.target.value)}
                                                label="Name" fullWidth autoFocus
                                                className={classes.input}/>
                                 </Grid>
                                 <Grid item xs={12}>
                                     <TextField value={email} onChange={e => setEmail(e.target.value)}
                                                label="Email" fullWidth type="email"
                                                className={classes.input}/>
                                 </Grid>
                                 <Grid item xs={12}>
                                     <NumberFormat id="Phone" label="Phone" value={phone} type="tel"
                                                   format="(###) ###-####" mask="_"
                                                   customInput={TextField} className={classes.input}
                                                   onValueChange={e => setPhone(e.value)}/>
                                 </Grid>
                                 <Grid item xs={12} sm={4}>
                                     <TextField value={city} onChange={e => setCity(e.target.value)}
                                                label="City/County"
                                                className={classes.input}/>
                                 </Grid>
                                 <Grid item xs={12} sm={4}>
                                     <TextField value={state} onChange={e => setState(e.target.value)}
                                                label="State"
                                                className={classes.input}/>
                                 </Grid>
                                 <Grid item xs={12} sm={4}>
                                     <TextField value={zipCode} onChange={e => setZipCode(e.target.value)}
                                                label="Zip Code"
                                                className={classes.input}/>
                                 </Grid>
                                 <Grid item xs={12}>
                                     <TextField value={comments} onChange={e => setComments(e.target.value)}
                                                label="Comments" fullWidth style={{marginTop: '1rem'}}
                                                multiline rows={4} rowsMax={8} variant="outlined"
                                                className={classes.input}/>
                                 </Grid>
                                 {errors ? <Grid item xs={12}>
                                     <Alert severity="error" onClose={() => setErrors("")}>{errors}</Alert>
                                 </Grid> : null}
                             </Grid>
                         </DialogContent>
                     </>}
                     actions={<>
                         <Button color="primary" onClick={() => {
                             onCancel();
                         }}>Back</Button>
                         <Button color="primary" variant="contained" onClick={() => {
                             const errors = [];
                             if(!email?.trim()) {
                                 errors.push('Email is required');
                             }
                             if(!name?.trim()) {
                                 errors.push('Name is required');
                             }
                             if(!city?.trim()) {
                                 errors.push('City is required');
                             }
                             if(!state?.trim()) {
                                 errors.push('State is required');
                             }
                             if(errors.length) {
                                 setErrors(errors.join(', '));
                             } else {
                                 onSubmit({
                                     name, email, phone, city, state, zipCode, comments
                                 })
                             }
                         }} startIcon={<SubmitIcon/>}>
                             Submit Inquiry
                         </Button>
                     </>}/>
    );
}

export default EmailOptionsDialog;